



import React, {Component} from 'react'
import CdnImage from '../../../../components/cdnImage/cdnImage.js'

const formatter = require('../../../../utils/formatter/formatter.js');
const stringUtil = require('../../../../utils/string/stringUtil.js');
const configurationManager = require('../../../../utils/config/configurationManager.js');

const translator = require('../../../../utils/translator/translator.js');

class CategoryItemWithImage extends Component 
{
    render()
    {
        var backgroundColor = "white"
        var foreColor = "var(--colors-text)"  
        
        return <div style={{
                            display:'flex',
                            flexDirection:'column',
                            border:'1px solid #00000020', 
                            minWidth:"calc(25% - 3px)",
                            maxWidth:"calc(25% - 3px)",
                            flex: '1 1 0px',
                            background:backgroundColor, color:foreColor,
                            textAlign:'center',
                            borderRadius:"var(--button-roundness)",
                            overflow:'hidden',
                            boxShadow: "0 0 12px var(--colors-primary20)"
                           }}
                    onClick={this.props.onClick}>                    
                        {this.renderMenuItemImage()}
                        <div style={{background:'#FFFFFF', 
                                     marginTop:'5px', 
                                     padding:'8px',
                                     flex:1,
                                     display:'flex',
                                     flexDirection:'column',
                                     justifyContent:'space-between'}}>
                            <div>
                                {this.renderMenuItemTitle()}
                                {this.renderMenuItemDescription()}
                            </div>
                            {this.renderMenuItemPrice()}
                        </div>
               </div>
    }
  
    renderMenuItemImage()
    {
        let item = this.props.item;
        let enabled = this.props.enabled;
        var width = Math.round(window.innerWidth * 0.14);
        var height = Math.floor(width * 0.50);

        var grayScale = !enabled;

        if (!stringUtil.isStringNullOrEmpty(item.imageUrl))
            return (<div className='category_item_image'>
                        <CdnImage cloudName={configurationManager.getConfig().cdnUsersCloudName} publicId={item.imageUrl} 
                                   width={width} height={height} radius="0" grayScale={grayScale} />
                    </div>);

        return (<div className='category_item_image'><CdnImage cloudName={configurationManager.getConfig().cdnAppCloudName} 
                                publicId="menus/default.menu.image.png" 
                                width={width} height={height} radius="0" /></div>);
    }

    renderMenuItemTitle()
    {
        let foreColor;
        if (this.props.snoozed || !this.props.enabled)
        {
            foreColor = "#808080";
        }

        let item = this.props.item;

        var caption = <div style={{
             textAlign:'left',
             fontWeight:'bold',
             lineHeight:1.3,
             color:foreColor
            }}>{item.caption}</div>;

        if (this.props.snoozed)
            caption = <div style={{color:foreColor}}>
                        <div>{item.caption}</div>
                        <div>{translator.getLabel("out_Of_stock")}</div>
                      </div>

        return caption;
    }

    renderMenuItemDescription()
    {
        let item = this.props.item;
        return (<div style={{ marginTop: '3px', textAlign:'left', lineHeight: 1.4}}>
            <small className="text-muted">
                {item.notes}
            </small>
        </div>);
    }

    renderMenuItemPrice()
    {
        let foreColor = 'var(--colors-primary)';
        if (this.props.snoozed || !this.props.enabled)
        {
            foreColor = "#808080";
        }

        let item = this.props.item;

        var priceLabel = "N/A";

        if (item.price != null)
        {
            priceLabel = formatter.convertToCurrencyFormat(item.price);
        }

        return (<div style={{marginTop:'10px', textAlign:'left', fontSize:"1.2rem", fontWeight:'bold', color:foreColor}}>{priceLabel}</div>);
    }
}

export default CategoryItemWithImage